export default {
  total: 0,
};
